// pages/ScrollToTop/ScrollTopButton.jsx
import { useState, useEffect, useCallback } from "react";
import { ArrowUpOutlined } from "@ant-design/icons";

const ScrollTopButton = () => {
  const [show, setShow] = useState(false);

  // Memoize scroll handler to prevent recreation
  const handleScroll = useCallback(() => {
    setShow(window.scrollY > 300);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Initial check

    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const scrollTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  if (!show) return null;

  return (
    <div className="scrollTopBtn" onClick={scrollTop}>
      <ArrowUpOutlined />
    </div>
  );
};

export default ScrollTopButton;